const OurLocalCommittees = () => {
  const LCS = [
    'Abeokuta',
    'Abuja',
    'Akure',
    'Benin',
    'Benue',
    'Calabar',
    'Ekiti',
    'Enugu',
    'Ibadan',
    'Ife',
    'Ilorin',
    'Jos',
    'Kano',
    'Lagos',
    'Port-Harcourt',
    'Zaria',
  ];

  return (
    <div className="flex flex-col gap-6 mb-16">
      <div className="flex flex-col gap-4 pt-[100px] pb-[50px] text-white px-3 md:px-0">
        {/* <h2 className="text-3xl md:text-5xl font-extralight italic text-center text-white">
          OUR <span className="font-bold not-italic">LOCAL COMMUNITIES</span>
        </h2>
        <p className="font-light italic text-xl leading-8 text-center">
          AIESEC is present in all these locations within the country.
        </p> */}
        <h2 className="text-3xl md:text-5xl font-extralight italic text-center text-[#20252F]">
          OUR <span className="font-bold not-italic">LOCAL CHAPTERS</span>
        </h2>
      </div>
      {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-6 justify-items-center w-full px-[10%]">
        {LCS.map((LC, index) => (
          <button
            key={index}
            className={`bg-[#20252F] text-white w-[160px] text-xl sm:text-lg sm:w-[240px] lg:text-2xl px-4 py-3 sm:px-3 sm:py-2 md:py-4 md:w-[140px] lg:w-[190px] xl:w-[240px] rounded-lg cursor-pointer
              active:scale-95 active:bg-opacity-90 ${
                index >= LCS.length - 2 ? 'md:col-span-2 ' : ''
              }`}
          >
            {LC}
          </button>
        ))}
      </div> */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 w-full px-[10%] justify-center">
        {LCS.map((LC, index) => (
          <button
            key={index}
            className="bg-[#20252F] text-left font-[500] text-white w-[140px] sm:w-[160px] md:w-[190px] lg:w-[220px] xl:w-[240px] text-lg lg:text-2xl px-6 py-4 rounded-lg cursor-pointer active:scale-95 active:bg-opacity-90"
          >
            {LC}
          </button>
        ))}
      </div>
      {/* <div className="lg:text-[20px] md:text-[15px] text-[#20252F] text-right flex flex-row flex-wrap justify-end items-start italic font-light py-[30px] px-[50px]">
        <div><div className="w-[15px] h-[15px] rounded-full bg-[#037EF3] mr-[10px] inline-block"></div>Recruitment is not open in Ekiti, Kano, and Zaria, currently.</div>
      </div> */}
    </div>
  );
};


// .p2 {
//   font-size: 20px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   align-self: right;
//   color: var(--dark-main, #20252f);
//   font-family: Lato;
//   font-style: italic;
//   font-weight: 300;
//   line-height: 28px;
//   text-align: right;
//   padding: 5vh 92px 0 600px;
// }
// .circle {
//   width: 15px;
//   height: 15px;
//   border-radius: 100%;
//   background-color: #037EF3;
//   margin-right: 10px;
//   display: inline-block;
// }

export default OurLocalCommittees;
